module.exports = __webpack_public_path__ + "static/media/wurfelori.44b08996.JPG";